import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass, Barcode } from "@phosphor-icons/react";

const CustomerSearch = forwardRef(function CustomerSearch(
    { code, setCode, searching, onSearch, onOpenScanner, onFocus },
    ref
) {
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                onSearch(code);
            }}
            className="flex gap-2 items-center"
        >
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#5C5F66] shrink-0">
                ΠΕΛΑΤΗΣ →
            </div>
            <div className="relative flex-1">
                <MagnifyingGlass
                    size={18}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5F66]"
                    weight="bold"
                />
                    <Input
                        ref={ref}
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        onFocus={() => onFocus && onFocus("customer")}
                        placeholder="Κωδικός / ΑΦΜ / Barcode πελάτη..."
                        data-testid="customer-search-input"
                        autoFocus
                        className="rounded-none h-12 pl-10 text-base font-semibold border-[#0A0A0A] border-2"
                    />
            </div>
            <Button
                type="button"
                onClick={onOpenScanner}
                data-testid="open-scanner-button"
                className="rounded-none h-12 w-12 px-0 bg-white border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white"
            >
                <Barcode size={20} weight="bold" />
            </Button>
            <Button
                type="submit"
                disabled={searching}
                data-testid="customer-search-button"
                className="rounded-none h-12 px-6 bg-[#002FA7] hover:bg-[#001D66] text-white font-bold"
            >
                {searching ? "..." : "ΑΝΑΖΗΤΗΣΗ"}
            </Button>
        </form>
    );
});

export default CustomerSearch;
